import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRetrievePlayerByUserId, useRetrieveTeam, useRetrieveUserTeamPermissions, useUpdateTeam, } from "../ApiProvider";
import { UserContext } from "../auth/UserProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { TeamForm } from "./TeamForm";
export const UpdateTeam = () => {
    const { id } = useNumericParams();
    const { data: userTeamPermissions, isLoading: userTeamPermissionsIsLoading, error: userTeamPermissionsError, } = useRetrieveUserTeamPermissions({ teamId: id });
    const { canModify = false } = userTeamPermissions || {};
    const { isLoading, error: teamError, data: team, } = useRetrieveTeam({ id, enabled: canModify });
    const { user: contextUser, loading: isContextUserLoading } = useContext(UserContext);
    const { data: player, isLoading: isPlayerLoading, error: playerError, } = useRetrievePlayerByUserId({
        userId: contextUser?.pk,
        enabled: canModify,
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const isPlayerInTeam = team && player
        ? (team.players || []).some((playerId) => playerId === player.id)
        : false;
    const isManagerOfTeam = team && contextUser ? team.manager === contextUser.pk : false;
    const mutation = useUpdateTeam({
        id,
        onMutate: () => {
            setLoading(true);
        },
        onSuccess: (data) => {
            const team = data.data;
            navigate(`/teams/${team.id}/`);
        },
        onError: () => { },
    });
    const onSubmit = (data) => {
        mutation.mutate(data);
    };
    if (userTeamPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userTeamPermissionsError) {
        return _jsx(ErrorView, { error: userTeamPermissionsError });
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (isLoading || loading || isContextUserLoading || isPlayerLoading) {
        return _jsx(Loading, {});
    }
    if (teamError || !team || playerError) {
        return _jsx(ErrorView, { error: teamError });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update team. Please try again.", onClose: () => { } }), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["Update ", team.name] }) }), _jsx(TeamForm, { team: team, onSubmit: onSubmit, defaultAddAsPlayer: isPlayerInTeam, defaultAddAsManager: isManagerOfTeam })] }));
};
